@if (isHeaderShown) {
  <app-header></app-header>
}
@if (isUserAgreementPending) {
  <app-user-agreement-modal
    [platform]="platform$ | async"
    (accepted)="onUserAgreementAccepted()"
  ></app-user-agreement-modal>
}
<router-outlet></router-outlet>

@if (isFooterShown) {
  <div class="footer" #footer>
    @for (btn of footerMenuOptions; track trackByFn($index)) {
      <div
        class="tab-icons"
        [class.tab-selected]="currentUrl.startsWith(btn.url)"
        (click)="navigate(btn.url)"
        [title]="btn.url"
      >
        <app-svg icon="{{ btn.img }}"></app-svg>
        @if (btn.url.includes(befreeUrlValues.notifications)) {
          <app-notifications-counter></app-notifications-counter>
        }
      </div>
    }
  </div>
}

<app-notification-container></app-notification-container>
